import { produce } from 'immer';
import { keys } from 'ramda';

import {
  CLEAR_FORECAST_DATA,
  CLEAR_POINT_OF_INTEREST,
  GET_ADVANCED_HOUSEHOLD_TYPES_DATA,
  GET_FOOTFALL_GRID_SUPPORTING_INFO,
  GET_FORECAST_DATA,
  GET_FORECAST_DATA_ASYNC,
  GET_FORECAST_DATA_ERROR,
  GET_POINT_OF_INTEREST,
  GET_POPULATION_STRUCTURE_DATA,
  GET_TARGET_CUSTOMER_SEARCH,
  GET_TARGET_CUSTOMER_SEARCH_HOUSEHOLD,
  REMOVE_DASHBOARD_DATA,
  SET_DASHBOARD_MAP_BOUND,
  SET_POINT_OF_INTEREST_VISIBLE,
  UPDATE_FOOTFALL_DATA,
  UPDATE_HOUSEHOLD_TYPES_SELECTED_POSTCODE,
  UPDATE_POPULATION_STRUCTURE_SELECTED_POSTCODE,
} from '../actions/types';
import { indicators } from '../pages/dashboards/dashboardFramework/maps/constants';

/* eslint default-case: "error" */

const forecastingDataReducer = produce(
  (draft, action) => {
    switch (action.type) {
      case GET_FORECAST_DATA:
        keys(action.payload.res).forEach((dataKey) => {
          draft[action.payload.key][dataKey] = action.payload.res[dataKey];
        });
        break;

      case GET_TARGET_CUSTOMER_SEARCH:
        draft[action.payload.key] = {
          ...(action.payload.data && action.payload.data),
          meta: action.payload.meta,
        };
        break;

      case GET_TARGET_CUSTOMER_SEARCH_HOUSEHOLD:
        draft[action.payload.key] = {
          ...(action.payload.data && action.payload.data),
          meta: action.payload.meta,
        };
        break;

      case GET_POPULATION_STRUCTURE_DATA:
        if (!draft[indicators.populationStructure]) {
          draft[indicators.populationStructure] = {};
        }

        draft[indicators.populationStructure][action.payload.dataKey] = {
          ...(action.payload.data && action.payload.data),
          meta: action.payload.meta,
        };
        break;

      case UPDATE_POPULATION_STRUCTURE_SELECTED_POSTCODE:
        draft[indicators.populationStructure].selectedPostcodeData = {
          ...(action.payload.data && action.payload.data),
        };
        break;

      case GET_ADVANCED_HOUSEHOLD_TYPES_DATA:
        draft[indicators.households][action.payload.dataKey] = {
          ...(action.payload.data && action.payload.data),
          meta: action.payload.meta,
        };
        break;

      case UPDATE_HOUSEHOLD_TYPES_SELECTED_POSTCODE:
        draft[indicators.households].selectedPostcodeData = {
          ...(action.payload.data && action.payload.data),
          meta: action.payload.meta,
        };
        break;

      // footfall
      case UPDATE_FOOTFALL_DATA:
        if (!draft[indicators.footfall]) {
          draft[indicators.footfall] = {};
        }
        // eslint-disable-next-line no-case-declarations
        const currData =
          action.payload.data ||
          draft[indicators.footfall][action.payload.dataKey] ||
          {};
        draft[indicators.footfall][action.payload.dataKey] = {
          ...currData,
          meta: action.payload.meta,
        };
        break;

      case GET_FOOTFALL_GRID_SUPPORTING_INFO:
        if (!draft[indicators.footfall]) {
          draft[indicators.footfall] = {};
        }
        draft[indicators.footfall].selectedGridSupportingInfo =
          action.payload.data;
        break;

      // common actions
      case GET_FORECAST_DATA_ASYNC:
        draft[action.payload.key] = draft[action.payload.key] || {};
        draft[action.payload.key].async = action.payload.async;
        break;

      case GET_FORECAST_DATA_ERROR:
        draft[action.payload.key] = draft[action.payload.key] || {};
        draft[action.payload.key].error = action.payload.error;
        break;

      case SET_DASHBOARD_MAP_BOUND:
        if (!draft[action.payload.key]) {
          draft[action.payload.key] = {};
        }
        draft[action.payload.key].mapBound = action.payload.data;
        break;

      case REMOVE_DASHBOARD_DATA:
        if (draft[action.payload]) {
          delete draft[action.payload];
        }
        break;

      case GET_POINT_OF_INTEREST:
        draft['Point of interest'] = {
          ...(action.payload.data && action.payload.data),
          meta: action.payload.meta,
        };
        break;

      case CLEAR_POINT_OF_INTEREST: {
        if (draft?.['Point of interest']) {
          delete draft['Point of interest'];
        }
        break;
      }

      case SET_POINT_OF_INTEREST_VISIBLE: {
        draft.isPointOfInterestVisible = action.payload;
        break;
      }

      case CLEAR_FORECAST_DATA:
        return {};

      // No Default
    }
  },
  { isPointOfInterestVisible: false },
);

export default forecastingDataReducer;
